module.exports = __webpack_public_path__ + "img/hw.1086ee57.png";